import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import config from '../config.json';

// Initialize Firebase
const firebaseApp = initializeApp(config.firebase);

// Initialize Firebase Authentication
export const auth = getAuth(firebaseApp);

// Configure Google provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('email');
googleProvider.addScope('profile');

// Optional: Force account selection for better UX
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default firebaseApp;
